import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { selectActiveCompanyId } from "../../../redux/features/user/selectors/userState.selectors";
import { getEventDeliveryConfig } from "../actions/getEventDeliveryConfig";

export const EVENT_DELIVERY_CONFIG_QUERY_KEY = "event-delivery-config";

export const useGetEventDeliveryConfig = () => {
  const companyId = useSelector(selectActiveCompanyId);

  return useQuery({
    queryKey: [EVENT_DELIVERY_CONFIG_QUERY_KEY, companyId],
    queryFn: getEventDeliveryConfig,
    enabled: Boolean(companyId),
  });
};
